import { dataFetcher } from 'core/services/requestHandler';   

const savePayouts = async (data = {}, config = {}) => {
  return dataFetcher('payouts', data, {method: 'POST', ...config});
};

const getPayouts = async (data = {}, config = {}) => {
  return dataFetcher('payouts', data, {...config});
};

const getVendorBankDetails = async (data = {}, config = {}) => {
  return dataFetcher('users/getVendorBankDetails', data, {...config});
};


export { savePayouts, getPayouts, getVendorBankDetails };
